import { render, staticRenderFns } from "./Assets.vue?vue&type=template&id=4c6f3ae2&scoped=true&"
import script from "./Assets.vue?vue&type=script&lang=js&"
export * from "./Assets.vue?vue&type=script&lang=js&"
import style0 from "./Assets.vue?vue&type=style&index=0&id=4c6f3ae2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6f3ae2",
  null
  
)

export default component.exports